/*globals $*/
(function(BDM, programDetail) {
    'use strict';

    var settings = {
            dataurl: "program_detail.json",
            shownumber: 100 /// Number of results to reveal initially and after load more
        },

        $el = { //stored elements
            container: $('.program-detail'),
            finder: $('.program-detail .location__field'),
            locationEdit: $('.program-detail .location__edit-window'),
            notfound: $('.program-detail__campus--notfound'),
            campus: $('.program-detail__campus'),
            locationLink: $('.program-detail__locations-link'),
            loading: $('.icon__loading'),
            value: $('.program-detail__value:first')
        },

        results,

        zipcode,

        resultsLoading = false,

        campus;
    /**
     *   Helper Methods
     **/


    function loadData() {

        if (resultsLoading === false) {
            resultsLoading = true;
            $el.campus.find('p').html('');
            $el.loading.addClass('fadein').removeClass('fadeout');
            $el.value.addClass('loading');
            if (zipcode !== $el.finder.val()) {
                zipcode = $el.finder.val();
                $.ajax({
                    type: 'POST',
                    url: settings.dataurl,
                    data: { zipcode: $el.finder.val(), programid: $el.container.attr('data-programid'), radius: $el.container.attr('data-radius'), itemid: $el.container.attr('data-item-id') },
                    dataType: 'json',
                    error: function(data) {
                        $el.campus.removeClass('active');
                        $el.notfound.addClass('active');
                        $el.value.removeClass('loading');
                        $el.loading.removeClass('fadein').addClass('fadeout');
                    },
                    success: function(data) {
                        //results = data.campus;
                        //showResults();
                        if (data.status == 0) {
                            clearDropdowns();
                        }
                        $el.loading.removeClass('fadein').addClass('fadeout');
                        $el.value.removeClass('loading');
                        if (data.status) {
                            $el.campus.find('p').html(data.message);
                            $el.campus.addClass('active');
                            $el.notfound.removeClass('active');
                        } else {
                            $el.notfound.find('p').html(data.message);
                            $el.campus.removeClass('active');
                            $el.notfound.addClass('active');
                        }
                    }
                });
            }
        }
    }

    /// Setup Events
    function bindEvents() {
        if ($el.locationEdit.length) {
            $el.locationEdit.on("click",function(event) {
                event.preventDefault();
                if ($el.locationEdit.hasClass('active')) {
                    if (/^([0-9]{5,})$/.test($el.finder.val()) && $el.finder.val() !== zipcode) {
                        resultsLoading = false;
                        loadData();
                    }
                }
            });
        }
        if ($el.finder.length) {
            $el.finder.keydown(function(event) {
                if (event.keyCode === 13) {
                    if (/^([0-9]{5,})$/.test($el.finder.val()) && $el.finder.val() !== zipcode) {
                        resultsLoading = false;
                        loadData();
                    }
                }
            });
            $el.finder.change(function(event) {
                if (/^([0-9]{5,})$/.test($el.finder.val()) && $el.finder.val() !== zipcode) {
                    resultsLoading = false;
                    loadData();
                }
            });
            setTimeout(function() { $el.finder.change(); }, 1000);
        }
    }

    /**
     *   Public Methods
     **/

    programDetail.init = function() {
        if ($el.finder.length) {
            settings.dataurl = $el.container.attr('data-programsurl') || settings.dataurl;
            bindEvents();
        }
    };
})(
    window.BDM = window.BDM || {},
    window.BDM.programDetail = window.BDM.programDetail || {}
);

//load when ready
$(function() {
    window.BDM.programDetail.init();
});